var semver = {exports: {}};
export { semver as __module };
